import 'isomorphic-fetch';

/**
 * The Transport class is simply an adapter to pass the request
 * from the ApiClient to the chosen method or library
 * We currently use fetch but it could be replaced by any HTTP client (Axios, etc.)
 */

const Transport = {
	// Define a common interface to handle different responses from the API
	response(ok, error, data = null) {
		return { ok, error, data };
	},
	async get(url) {
		try {
			const response = await this.fetch(
				url,
				{
					method: 'GET'
				},
			);
			if (!response.ok) {
				throw new Error(document.getElementById('api-error-text').innerHTML);
			}
			const data = await response.json();
			return this.response(response.ok, null, data);
		} catch (error) {
			return this.response(false, error.message);
		}
	},
	async fetch(url, options) {
    return fetch(url, options);
  }
};

export default Transport;
